import { render, staticRenderFns } from "./SSOCallback.vue?vue&type=template&id=1f71dd9f&scoped=true"
import script from "./SSOCallback.vue?vue&type=script&lang=js"
export * from "./SSOCallback.vue?vue&type=script&lang=js"
import style0 from "./SSOCallback.vue?vue&type=style&index=0&id=1f71dd9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71dd9f",
  null
  
)

export default component.exports